import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      padding: theme.spacing(5, 0),
    },
  };
});

const KpiCardGroup = ({ children, className, spacing, ...props }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={spacing}
      className={clsx(classes.root, className)}
      {...props}
    >
      {children}
    </Grid>
  );
};

KpiCardGroup.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  spacing: PropTypes.number,
};

KpiCardGroup.defaultProps = {
  spacing: 3,
};

export default KpiCardGroup;
